import React, { useState } from 'react'
import Modal from '../../components/Modal'
import Text from '../../components/Text'
import ForgotForm from '../../forms/Forgot'
import { Container, Form } from './styles'
import { useHistory } from 'react-router-dom'
import routes from '../../config/routes'
import { GuestArea } from '@polvo-labs/react-auth'
import Button from '../../components/Button'

interface Props {

}

const ForgotScreen: React.FC<Props> = () => {
  const history = useHistory()
  const [submitted, setSubmitted] = useState(false)

  return (
    <GuestArea>
      <Modal
        open
        small
        onToggle={() => history.push(routes.index.path)}
      >
        <Container>
          <Form>
            <Text
              tag="h2"
              align="center"
            >
              ESQUECI MINHA SENHA
            </Text>

            {!submitted ? (
              <ForgotForm
                onSubmit={() => setSubmitted(true)}
              />
            ) : (
              <>
                <p>Enviamos um email com as instruções para você recuperar sua
                senha de acesso.</p>

                <Button
                  label="ENTENDI"
                  block
                  onClick={() => history.push(routes.index.path)}
                />
              </>
            )}
          </Form>
        </Container>
      </Modal>
    </GuestArea>
  )
}

export default ForgotScreen
